const doc = [({"name":"Servo", "summary":"Servo is a modern, high-performance browser engine designed for both application and embedded use.", "repositories":[({"servo/servo":"E-easy"})]})];
module.exports = doc.length <= 1 ? doc[0] : doc;